import {
  defaultLifeCycle, destroyStates, readStates, saveStates,
} from '@/constants/lifecycle';

const cohortActions = {
  ADD_DICTIONARY_TO_COHORT: 'ADD_DICTIONARY_TO_COHORT',
  CLOSE_COHORT: 'CLOSE_COHORT',
  CLOSE_COHORTS: 'CLOSE_COHORTS',
  CREATE_COHORT: 'CREATE_COHORT',
  DATASET_TO_COHORT: 'DATASET_TO_COHORT',
  DELETE_COHORT: 'DELETE_COHORT',
  DESTROY_COHORT: 'DESTROY_COHORT',
  DESTROY_COHORT_ERROR: 'DESTROY_COHORT_ERROR',
  EDIT_COHORT: 'EDIT_COHORT',
  EDIT_COHORT_ERROR: 'EDIT_COHORT_ERROR',
  EDIT_COHORT_SUCCESS: 'EDIT_COHORT_SUCCESS',
  FETCH_COHORT: 'FETCH_COHORT',
  FETCH_COHORT_DATASETS: 'FETCH_COHORT_DATASETS',
  FETCH_COHORT_DICTIONARIES: 'FETCH_COHORT_DICTIONARIES',
  FETCH_COHORTS: 'FETCH_COHORTS',
  HIDE_DELETE_COHORT: 'HIDE_DELETE_COHORT',
  HIDE_SAVE_COHORT: 'HIDE_SAVE_COHORT',
  NEW_COHORT: 'NEW_COHORT',
  NEW_COHORT_ERROR: 'NEW_COHORT_ERROR',
  NEW_COHORT_FROM_DATASET: 'NEW_COHORT_FROM_DATASET',
  REFRESH_COHORTS: 'REFRESH_COHORTS',
  REMOVE_DICTIONARY_FROM_COHORT: 'REMOVE_DICTIONARY_FROM_COHORT',
  SHOW_COHORT: 'SHOW_COHORT',
  SHOW_COHORTS: 'SHOW_COHORTS',
  SHOW_COHORTS_ERROR: 'SHOW_COHORTS_ERROR',
  SHOW_COHORT_DATASETS: 'SHOW_COHORT_DATASETS',
  SHOW_COHORT_DICTIONARIES: 'SHOW_COHORT_DICTIONARIES',
  SHOW_COHORT_ERROR: 'SHOW_COHORT_ERROR',
  SHOW_DELETE_COHORT: 'SHOW_DELETE_COHORT',
  SHOW_DELETE_COHORTS: 'SHOW_DELETE_COHORTS',
  SHOW_SAVE_COHORT: 'SHOW_SAVE_COHORT',
  TOGGLE_COHORTS_PRESENTATION: 'TOGGLE_COHORTS_PRESENTATION',
  TOGGLE_COHORTS_SELECTED: 'TOGGLE_COHORTS_SELECTED',
  TOGGLE_COHORT_DATASET_SELECTED: 'TOGGLE_COHORT_DATASET_SELECTED',
  TOGGLE_COHORT_DICTIONARY_SELECTED: 'TOGGLE_COHORT_DICTIONARY_SELECTED',
  TOGGLE_COHORT_SELECTED: 'TOGGLE_COHORT_SELECTED',
  TOGGLE_EXPANDED_CHARTS: 'TOGGLE_EXPANDED_CHARTS',
  UPDATE_ACTIVE_COHORT_PROPERTIES: 'UPDATE_ACTIVE_COHORT_PROPERTIES',
  UPDATE_COHORT: 'UPDATE_COHORT',
  UPDATE_COHORTS_FILTER: 'UPDATE_COHORTS_FILTER',
  UPDATE_COHORTS_FLAGS: 'UPDATE_COHORTS_FLAGS',
  UPDATE_COHORT_CANCEL: 'UPDATE_COHORT_CANCEL',
  UPDATE_COHORT_DATASETS_FILTER: 'UPDATE_COHORT_DATASETS_FILTER',
  UPDATE_COHORT_DATASETS_FLAGS: 'UPDATE_COHORT_DATASETS_FLAGS',
  UPDATE_COHORT_DICTIONARIES_FILTER: 'UPDATE_COHORT_DICTIONARIES_FILTER',
  UPDATE_COHORT_PANELS: 'UPDATE_COHORT_PANELS',
  UPDATE_COHORT_PROPERTIES: 'UPDATE_COHORT_PROPERTIES',
};

export const cohortLists = ['saved', 'ribbon'];

export const cohortCategories = [...cohortLists, 'open', 'deletion'];

export const cohortLifeCycle = [...defaultLifeCycle];

export const cohortStates = {
  ...readStates,
  ...saveStates,
  ...destroyStates,
};

export const cohortPermissions = {
  UPDATE: 'can_update',
  DESTROY: 'can_destroy',
  VISIBILITY: 'can_change_visibility',
  SECURITY: 'can_manage_perms',
  INVITE_MEMBER: 'can_invite_user',
  REMOVE_MEMBER: 'can_remove_user',
  AUDIT: 'can_read_audit',
};

export default cohortActions;
